import axios from './axios';
import { SurveyQuestion } from '../redux/types/survey';

export const loadQuestions = () => axios.get('/survey/questions');
export const updateQuestions = (questions: SurveyQuestion[]) => axios.post('/survey/questions', questions);
export const loadPostTourQuestions = () => axios.get('/survey/postTour/questions');
export const updatePostTourQuestions = (questions: SurveyQuestion[]) => axios.post('/survey/postTour/questions', questions);
